export default __webpack_public_path__ + "static/media/gallery_07.d23d2902.jpg";